import { z } from 'zod';

export const hubspotContentTypeSchema: z.ZodNativeEnum<{
	readonly Deal: 'deal';
	readonly CustomerOrg: 'customer-org';
}> = z.nativeEnum({
	Deal: 'deal',
	CustomerOrg: 'customer-org',
} as const);
